import React, { useState, useEffect } from "react";
import CustomButton from "../Form/CustomButton";

const PartnersSection = ({ partners = [], onContactClick }) => {
  const [index, setIndex] = useState(0);
  const hasMany = partners.length > 1;

  const goTo = (i) => setIndex((i + partners.length) % partners.length);

  // Auto rotate
  useEffect(() => {
    if (!hasMany) return; // don’t auto rotate if only one
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % partners.length);
    }, 3000); // change every 4s

    return () => clearInterval(interval);
  }, [partners.length, hasMany]);

  const current = partners[index];

  return (
    <section className="w-11/12 xl:w-full mx-auto grid grid-cols-1 xl:grid-cols-[1fr,1.2fr] gap-8 xl:gap-14 items-center pb-14 sm:pb-20 md:pb-[120px] py-0 md:py-0 xl:px-[7.5rem]">
      {/* Left copy */}
      <div className="px-2 md:px-0">
        <div className="xl:w-[90px] xl:h-[9px] xl:ml-3 xl:mb-[23px] w-[75px] h-[8px] ml-3 mb-[16px] bg-gradient-blue" />
        <h2 className="font-alexandria font-semibold text-[#071952] text-[1.75rem] xs:text-[2rem] md:text-4xl xl:text-[46px] leading-[100%] mb-9">
          Our Partners
        </h2>

        <h3 className="font-poppins font-medium text-[#494949] text-lg md:text-[24px] mb-4">
          Partner with Us
        </h3>
        <p className="font-poppins text-[#494949] text-[14px] md:text-[18px] max-w-prose mb-9">
          Join hands with us to make landlords’ lives easier and more comfortable.
        </p>

        <CustomButton
          buttonText="Contact Us"
          type="button"
          className="rounded-[5px] md:rounded-[3px] text-[14px] md:text-[20px] font-poppins font-semibold bg-gradient-blue shadow-custom-blue text-white px-[0.9rem] py-[0.7rem] border-none"
          width="w-[8rcm] md:w-[11.75rem]"
          height="h-[2.5rcm] md:h-[3.875rem]"
          hoverEffect="none"
          onClick={onContactClick}
        />
      </div>

      {/* Right card */}
      <div className="relative">
        <div className="rounded-[25px] border-[1px] border-[#EDEDED61] drop-shadow-[0px_4px_4px_#8E8E8E40] bg-gradient-light-sky px-4 sm:px-8 md:px-10 h-[240px] sm:h-[280px] md:h-[367px] flex flex-col items-center justify-center">
          {/* Logo area */}
          <a
            href={current?.href || "#"}
            target={current?.href ? "_blank" : "_self"}
            rel="noreferrer"
            className="flex items-center h-[225px] justify-center"
            aria-label={current?.name || "Partner"}
          >
            <img
              src={current?.logoSrc}
              alt={current?.name || "Partner logo"}
              className="max-h-20 sm:max-h-24 md:max-h-28 object-contain"
            />
          </a>

          {/* Name */}
          <div className="mt-[10px] font-poppins font-semibold text-[#494949] text-sm sm:text-base md:text-[24px] tracking-wide leading-[100%] p-[15px]">
            {current?.name}
          </div>

          {/* Dots */}
          {hasMany && (
          <div className="mt-[18px] flex items-center gap-[14px]">
            {partners.map((_, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                aria-label={`Go to partner ${i + 1}`}
                className={`h-[8px] w-[8px] rounded-full transition 
                  ${i === index ? "bg-[#09114B]" : "bg-[#9D9D9D]"}`}
              />
            ))}
          </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
